export const FIND_ALL_CATEGORY_REQUEST = "FIND_ALL_CATEGORY_REQUEST";
export const FIND_ALL_CATEGORY_SUCCESS = "FIND_ALL_CATEGORY_SUCCESS";
export const FIND_ALL_CATEGORY_FAIL = "FIND_ALL_CATEGORY_FAIL";

export const FIND_ONE_CATEGORY_REQUEST = "FIND_ONE_CATEGORY_REQUEST";
export const FIND_ONE_CATEGORY_SUCCESS = "FIND_ONE_CATEGORY_SUCCESS";
export const FIND_ONE_CATEGORY_FAIL = "FIND_ONE_CATEGORY_FAIL";

